
import React from 'react';
import { InputAdornment, TextField } from '@mui/material';
import { CHANGE_DISCOUNT, SET_DISCOUNT } from '../engineeringActions';
import { connect } from 'react-redux';
import { dispatch } from '__common/store';

type Props = {
  dispatch: Function,
  discount: number | null,
  projectId: string,
};

class EngineeringDiscount extends React.Component<Props> {
  changeDiscount = (discount: number) => {
    const { dispatch } = this.props;
    dispatch(CHANGE_DISCOUNT(discount));
  }

  applyDiscountHandler = () => {
    const { discount, projectId } = this.props;

    dispatch(SET_DISCOUNT(projectId, discount));
  }

  render() {
    const { discount } = this.props;

    return (
      <div className="engineering-discount pb-3">
        <div className="discount-input">
          <label className="input-label" htmlFor="discount_input">discount</label>
          <div className="discount-container">
            <TextField
              className="discount-field"
              id="discount_input"
              variant="standard"
              type="text"
              inputProps={{ inputMode: 'decimal' }}
              InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <InputAdornment position="end" className="percentage-sign" disableTypography>
                    %
                  </InputAdornment>
                ),
              }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => this.changeDiscount(Number(event.target.value))}
              value={discount === null ? 0 : discount}
            />
          </div>
        </div>
        <div className="save-changes-button" onClick={this.applyDiscountHandler}>
          APPLY DISCOUNT
        </div>
      </div>
    );
  }
}

function mapStateToProps(appState: appState) {
  return {
    discount: appState.engineering.projectInfo.discount,
  };
}

export default connect(mapStateToProps)(EngineeringDiscount);
